import { AutomoxPoliciesColumnsType } from './AutomoxPoliciesColumns';

export const AUTOMOX_POLICIES_MOCK_DATA: AutomoxPoliciesColumnsType[] = [
    { id: '1', policyName: '[APD-480] AppleScript Dynamic Content Popup - 7dfvFpcxKsyo', status: 'ENABLED' },
    {
        id: '2',
        policyName: '[APD-480] AppleScript Dynamic Content Popup - 77hMwruUKTk4',
        status: 'ENABLED',
    }
];